// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dd99811e","667":"3a97ca23"}[chunkId] + ".chunk.js";
};